import { render, staticRenderFns } from "./FlightLeg.vue?vue&type=template&id=3ea53185&scoped=true"
import script from "./FlightLeg.vue?vue&type=script&lang=js"
export * from "./FlightLeg.vue?vue&type=script&lang=js"
import style0 from "./FlightLeg.vue?vue&type=style&index=0&id=3ea53185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea53185",
  null
  
)

export default component.exports